<template>
    <div uk-grid uk-height-match=">div>.uk-card">
        <address-item v-for="item in addresses" :is-default="item.id == defaultKey" :address="item" :key="item.id"></address-item>
    </div>
</template>

<script>
    export default {
      props: {
        defaultKey: {
          type: String,
        }
      },
      data() {
        return {
          processed: [],
        }
      },
      computed: {
        addresses() {
          return this.$store.state.addressBook.addresses;
        }
      },
    }
</script>



// WEBPACK FOOTER //
// public/themes/frontend/uikit3/extensions/rubinred/ecommerce/assets/js/components/addressing/AddressesList.vue